export default function Device() {
  // Dynamic image imports
  function importAll(requireContext) {
    return requireContext
      .keys()
      .map((key) => ({ key, src: requireContext(key) }));
  }

  const deviceImagesContext = require.context(
    "../assets/cover/device",
    false,
    /\.(png|jpe?g|svg)$/
  );
  const deviceImages = importAll(deviceImagesContext)
    .sort((a, b) => a.key.localeCompare(b.key))
    .map((x) => x.src);

  // Device data with names
  const devices = [
    {
      name: "Amazon Fire TV",
      image: deviceImages[0] || "./assets/cover/device/amz.png",
    },
    {
      name: "Android",
      image: deviceImages[1] || "./assets/cover/device/android.png",
    },
    {
      name: "Android TV",
      image: deviceImages[2] || "./assets/cover/device/androidtv copy.png",
    },
    {
      name: "Apple TV",
      image: deviceImages[3] || "./assets/cover/device/applelog.png",
    },
    {
      name: "Chromecast",
      image: deviceImages[4] || "./assets/cover/device/chrom.png",
    },
    {
      name: "Formuler",
      image: deviceImages[5] || "./assets/cover/device/formuller.png",
    },
    {
      name: "Huawei",
      image: deviceImages[6] || "./assets/cover/device/huawei.png",
    },
    { name: "LG", image: deviceImages[7] || "./assets/cover/device/lg.png" },
    {
      name: "Lonov",
      image: deviceImages[8] || "./assets/cover/device/lonov.png",
    },
    {
      name: "Microsoft",
      image: deviceImages[9] || "./assets/cover/device/micro.png",
    },
    {
      name: "Philips",
      image: deviceImages[10] || "./assets/cover/device/phili.png",
    },
    {
      name: "Samsung",
      image: deviceImages[11] || "./assets/cover/device/sams.png",
    },
    {
      name: "Sharp",
      image: deviceImages[12] || "./assets/cover/device/sharp.png",
    },
    {
      name: "Sony",
      image: deviceImages[13] || "./assets/cover/device/sony.png",
    },
    { name: "TCL", image: deviceImages[14] || "./assets/cover/device/tcl.png" },
    {
      name: "Toshiba",
      image: deviceImages[15] || "./assets/cover/device/tosh.png",
    },
    {
      name: "Xiaomi",
      image: deviceImages[16] || "./assets/cover/device/xiaomi.png",
    },
    { name: "X96", image: deviceImages[17] || "./assets/cover/device/x96.png" },
  ];

  return (
    <section className="py-8">
      <div className="w-[90%] sm:w-[90%] md:w-[85%] m-auto">
        <div className="text-center mb-12 sm:mb-16">
          <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl mx-auto font-black max-w-3xl leading-snug text-center text-orange-500">
            Compatible con todos los dispositivos
          </h1>
        </div>

        <div className="flex justify-center">
          <div className="grid grid-cols-3 lg:grid-cols-6 gap-x-3 gap-y-3 place-items-center">
          {devices.map((device, index) => (
            <div key={index} className="device-item group">
              <div className="w-20 h-16 md:w-24 md:h-16 bg-white/5 backdrop-blur-sm rounded-2xl py-4 px-3 flex items-center justify-center border border-white/10 group-hover:bg-white/10 group-hover:border-orange-400/30 transition-all duration-300 shadow-lg group-hover:shadow-orange-400/10">
                <img
                  src={device.image}
                  alt={device.name}
                  className="w-full h-full object-contain filter brightness-0 invert group-hover:filter-none group-hover:brightness-110 transition-all duration-300"
                />
              </div>
            </div>
          ))}
          </div>
        </div>

        <div className="text-center mt-12 sm:mt-16">
          <div className="contact-pricing rounded-2xl p-6 sm:p-8 border border-red-100/20">
            <h3 className="text-lg sm:text-xl md:text-2xl font-bold text-white mb-4">
              ¿Listo para comenzar en tu dispositivo favorito?
            </h3>
            <p className="text-gray-100 text-sm sm:text-base mb-6 max-w-2xl mx-auto">
              Instalación simple y rápida en todos estos dispositivos. Soporte
              técnico incluido.
            </p>
            <a
              href="#pricing"
              className="w-full md:w-96 bg-orange-500 hover:bg-orange-600 text-white font-black py-3 sm:py-4 px-6 sm:px-8 rounded-xl text-sm sm:text-base transition-all duration-700 transform shadow-2xl hover:shadow-orange-500/30 hover:shadow-2xl hover:-translate-y-1 flex items-center justify-center gap-2 sm:gap-3 cursor-pointer mx-auto"
            >
              <svg
                className="w-4 h-4 sm:w-5 sm:h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M3 1a1 1 0 000 2h1.22l.305 1.222a.997.997 0 00.01.042l1.358 5.43-.893.892C3.74 11.846 4.632 14 6.414 14H15a1 1 0 000-2H6.414l1-1H14a1 1 0 00.894-.553l3-6A1 1 0 0017 3H6.28l-.31-1.243A1 1 0 005 1H3zM16 16.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0zM6.5 18a1.5 1.5 0 100-3 1.5 1.5 0 000 3z" />
              </svg>
              Comprar ahora
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
